var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsperityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#439539",
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.3 18.1c-1 .1-2.1-.3-2.9-.9l.2 1.5c.7.4 1.5.5 2.3.4-.1.8.1 1.6.4 2.3l1.6.2c-.6-.8-.9-1.9-.9-2.9.1-.3-.2-.6-.5-.7-.1.1-.1.1-.2.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.6 16.4c-2 .2-4-.4-5.6-1.6l-.3-2c1.8 1.2 3.4 2.3 6.1 2.2.9 0 1.1.2 1.1 1.1-.1 2.6 1 4.3 2.2 6l-2-.2c-1.1-1.6-1.7-3.5-1.5-5.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.6 13.5c-1.6.3-5.1.2-9-2.9-.2-1.4-.3-2-.3-2 1.8 1.5 5.3 3.8 9.3 3.5 1.2-.1 1.5.2 1.4 1.4-.3 4 2 7.4 3.5 9.2 0 0-.6-.1-2-.2-3-3.9-3.2-7.4-2.9-9zM30 29.2c-.1-1 .3-2.1.9-2.9l-1.6.2c-.4.7-.5 1.5-.4 2.3-.8-.1-1.6.1-2.3.4l-.2 1.6c.8-.6 1.9-1 2.9-.9.3.1.6-.1.7-.4v-.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.6 31.6c-.2-2 .4-4 1.6-5.5l2-.3c-1.2 1.8-2.3 3.4-2.2 6 0 .9-.3 1.1-1.1 1.1-2.6-.1-4.3.9-6.1 2.2l.2-1.9c1.7-1.3 3.7-1.9 5.6-1.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.6 34.5c-.3-1.6-.2-5 2.9-9 1.5-.2 2-.3 2-.3-1.5 1.8-3.8 5.3-3.5 9.3.1 1.2-.2 1.5-1.4 1.4-4-.3-7.5 2-9.3 3.5 0 0 .1-.6.3-2 4-3 7.4-3.2 9-2.9zm-15.9-4.6c1-.1 2.1.2 2.9.9l-.2-1.6c-.7-.3-1.5-.5-2.3-.4.1-.8-.1-1.6-.4-2.3l-1.6-.2c.6.8.9 1.9.9 2.9 0 .5.2.7.7.7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.4 31.6c2-.2 4 .4 5.6 1.6l.3 2c-1.8-1.2-3.4-2.3-6.1-2.2-.9 0-1.1-.2-1.1-1.1.1-2.6-.9-4.2-2.2-6l2 .2c1.1 1.6 1.7 3.5 1.5 5.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.4 34.5c1.6-.3 5.1-.2 9 2.8.2 1.5.3 2 .3 2-1.8-1.5-5.3-3.8-9.3-3.5-1.2.1-1.5-.2-1.4-1.4.3-4-2-7.5-3.5-9.2 0 0 .6.1 2.1.3 3 3.9 3.1 7.4 2.8 9zM18 18.8c0 1-.3 2.1-.9 2.9l1.6-.2c.4-.7.5-1.5.4-2.3.8.1 1.6-.1 2.3-.4l.2-1.6c-.9.6-1.9.9-3 .9-.3-.1-.6.2-.7.5.1 0 .1.1.1.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.4 16.4c.2 2-.3 4-1.6 5.6l-2 .3c1.3-1.8 2.3-3.4 2.2-6 0-.8.2-1.1 1.1-1.1 2.6.1 4.3-.9 6.1-2.2l-.2 1.9c-1.7 1.2-3.6 1.8-5.6 1.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.4 13.5c.3 1.6.2 5-2.9 9-1.5.2-2 .3-2 .3 1.5-1.8 3.8-5.3 3.5-9.3-.1-1.2.1-1.5 1.4-1.4 4 .3 7.5-2 9.3-3.5 0 0-.1.6-.3 2-4 3-7.4 3.2-9 2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsperityLogo);
export default __webpack_public_path__ + "static/media/insperityLogo.a64222d7a57983d36478de50da0e6383.svg";
export { ForwardRef as ReactComponent };